angular
  .module('app.views')
  .controller('TemplateChooserController', function ($scope, $modalInstance, $q, Pandadoc) {
    $scope.folderStack = [{uuid: "", name: ""}];

    $scope.loadFolder = (folder) => {
      $scope.isLoading = true;
      let p1 = Pandadoc.getTemplates({folder_id: folder.uuid}).$promise
      let p2 = Pandadoc.getTemplateFolders({folder_id: folder.uuid}).$promise
    
      $q.all([p1, p2]).then(results => {
        $scope.templates = results[0];
        $scope.folders = results[1];
        $scope.isLoading = false;
      });
    }

    $scope.selectFolder = (folder) => {
      $scope.folderStack.push(folder);
      $scope.loadFolder(folder);
    }

    $scope.selectTemplate = (template) => {
      $modalInstance.close(template);
    }

    $scope.loadFolder($scope.folderStack[0]);

    $scope.back = (folder) => {
      while ($scope.folderStack[$scope.folderStack.length-1].uuid != folder.uuid) {
        $scope.folderStack.pop();
      }
      $scope.loadFolder(folder);
    }

    return $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/upgrade/template_chooser_controller.js